'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getActiveLanguageAndCountryCode = exports.getActiveLanguageCode = undefined;

var _reselect = require('reselect');

var countryCodeMapping = {
    en: 'en-gb',
    de: 'de-de',
    fr: 'fr-fr',
    es: 'es-es',
    pt: 'pt-pt',
    sv: 'sv-se',
    ja: 'ja-jp',
    ru: 'ru-ru',
    cn: 'zh-cn',
    zh: 'zh-hk',
    el: 'el-gr',
    cs: 'cs-cz',
    it: 'it-it',
    pl: 'pl-pl',
    fi: 'fi-fi',
    hu: 'hu-hu',
    ro: 'ro-ro',
    sl: 'sl-sl',
    sr: 'sr-yu',
    ie: 'en-ie',
    ca: 'en-ca',
    at: 'de-at'
};

/**
 * Gets the full language string from a language code to be used when making requests to squiz and other backends
 * @param {String} langCode The language code
 * @return {String} The full language string or undefined
 */
var getCountryCodeFromLangCode = function getCountryCodeFromLangCode(langCode) {
    return countryCodeMapping[langCode];
};

var getLanguageCode = function getLanguageCode(state) {
    return state.getIn(['settings', 'language'], 'en');
};

/**
 * Get the current active language
 * @param {Map} state The redux state
 * @return {String} The currently active language
 */
var getActiveLanguageCode = exports.getActiveLanguageCode = (0, _reselect.createSelector)([getLanguageCode], function (langCode) {
    return langCode;
});

/**
 * Gets the full language string ie: en-gb or the lang code is no specific mapping has been found for the active
 * language code
 */
var getActiveLanguageAndCountryCode = exports.getActiveLanguageAndCountryCode = (0, _reselect.createSelector)([getLanguageCode], function (langCode) {
    return getCountryCodeFromLangCode(langCode) || langCode;
});
//# sourceMappingURL=selectors.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/language-common/dist/main/selectors.js
// module id = 469
// module chunks = 0